import ztComponent from './ztCheckBox.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
